import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../providers/auth/auth.service';
import { HelpersProvider } from '../../providers/helpers/helpers';
import { environment } from '../../environments/environment';
import {
  applyLayoutTheme,
  canUseLayoutTheme,
  LAYOUT_THEMES,
  LAYOUT_THEME_STORAGE_KEY,
  LayoutThemeValue,
  normalizeLayoutTheme,
} from '../../providers/layout-theme/layout-theme';

@Component({
  selector: 'app-nav-master',
  templateUrl: './nav-master.component.html',
  styleUrls: ['./nav-master.component.scss']
})
export class NavMasterComponent implements OnInit {
  readonly layoutThemes = LAYOUT_THEMES;
  readonly layoutThemeStorageKey = LAYOUT_THEME_STORAGE_KEY;

  @ViewChild('snav', {static: false}) sidenav: MatSidenav;
  public user: any;
  minimize = false;
  selectedTheme: any;
  selectedLayoutTheme: LayoutThemeValue = 'modern-dark';
  canShowLayoutThemeSelector = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    public helpers: HelpersProvider,
  ) {
    //
  }

  ngOnInit() {
    this.user = this.auth.retrieveLocalUser();
    this.canShowLayoutThemeSelector = this.canUseLayoutThemeSelector();
    this.selectedLayoutTheme = this.canShowLayoutThemeSelector
      ? this.normalizeLayoutTheme(localStorage.getItem(this.layoutThemeStorageKey))
      : 'modern-dark';
    if (this.canShowLayoutThemeSelector) {
      localStorage.setItem(this.layoutThemeStorageKey, this.selectedLayoutTheme);
    }
    this.applyLayoutTheme(this.selectedLayoutTheme);
  }

  toogleMini() {
    // console.log('minimenu');
    this.minimize = !this.minimize;
  }

  closeSnav() {
    this.sidenav.close();
    this.minimize = false;
  }

  changeTheme() {
    console.log(this.selectedTheme);
    // document.body.classList.add('is-safari');
    // document.body.classList.remove('class');
  }

  changeLayoutTheme(theme: string) {
    if (!this.canShowLayoutThemeSelector) return;

    this.selectedLayoutTheme = normalizeLayoutTheme(theme);
    localStorage.setItem(this.layoutThemeStorageKey, this.selectedLayoutTheme);
    this.applyLayoutTheme(this.selectedLayoutTheme);
  }

  getSelectedLayoutThemeLabel() {
    const selectedTheme = this.layoutThemes.find(layoutTheme => layoutTheme.value === this.selectedLayoutTheme);

    return selectedTheme ? selectedTheme.label : 'Classic dark';
  }

  normalizeLayoutTheme(theme: string) {
    return normalizeLayoutTheme(theme);
  }

  canUseLayoutThemeSelector() {
    return canUseLayoutTheme(this.user, environment.dev);
  }

  applyLayoutTheme(theme: string) {
    applyLayoutTheme(normalizeLayoutTheme(theme));
  }

}
